import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {


  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
      console.error(chunkFailedMessage);
      return;
    } else {
      try {
        console.error(error.stack.toString());
      } catch (_) {
        console.error(error);
      }
    }

  }
}
